import { render } from "./JoinForm.vue?vue&type=template&id=1a67d770"
import script from "./JoinForm.vue?vue&type=script&lang=js"
export * from "./JoinForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__